// @flow

import * as React from "react";

import NumberInput from "../NumberInput";

type PercentageInputProps = {};

const PercentageInput = (props: PercentageInputProps) => (
  <NumberInput {...props} sideSymbol={() => "%"} />
);

export default PercentageInput;
